module.exports = "https://cdn.hellotech.com/client-assets/affirm_monthly_payments_b1d65edafcaff32c9e700c995699e27c.svg";